export const VERSION_TEXT = 'Version:';
export const DASHBOARD_LABEL = 'DASHBOARD';
export const QUEUE_LABEL = 'QUEUE';
export const REPORTING_LABEL = 'REPORTING';
export const ADVISE_REPORTING_LABEL = 'ADVISE REPORTING';
export const ADVANCED_DRAGONFLY_REPORTING_LABEL =
  'ADVANCED DRAGONFLY REPORTING';
export const ADMIN_LABEL = 'ADMIN';
export const SEARCH_LABEL = 'SEARCH';
export const TOOLS_LABEL = 'TOOLS';
export const CMS_IPO_LIST_LABEL = 'CMS IPO List';
export const PROFILE_LABEL = 'PROFILE';
export const SIGN_OUT_LABEL = 'SIGN OUT';
export const SIGN_IN_LABEL = 'SIGN IN';
export const AUTO_ASSIGN_LABEL = 'AUTO ASSIGN';
export const CORTEX_CLIENT_SUPPORT_LABEL = 'CORTEX Client Support';
export const HELP_MODAL_TITLE = 'CORTEX.PA Help';
export const DOWNLOAD_USER_GUIDE_LABEL = 'Download the user guide';
export const DOWNLOAD_USER_GUIDE_TITLE = 'Download User Guide';
export const CORTEX_CLIENT_URL = 'http://support.xsolis.com';
export const CORTEX_CLIENT_SUPPORT_DESCRIPTION =
  'To contact customer support, please click on the link to open a service desk ticket: ';
